import { FC } from 'react';
import { SimpleGrid } from '@chakra-ui/react';

import * as Form from 'components/_core/form';
import { calcApportionedShares } from 'features/Onboarding/modules/Beneficiaries/libs/calcApportionnedShares';

import locales from './locales';
import { ManageSharesProps } from './types';

const getNumberOfSharesInputError = (
  numberOfShares: number | null,
  isGlobalAmountValid: boolean,
): string | null => {
  if (numberOfShares === null) {
    return null;
  }
  if (!Number.isInteger(numberOfShares)) {
    return locales.numberOfSharesNotIntegerError;
  }
  if (numberOfShares <= 0) {
    return locales.numberOfSharesNotPositiveError;
  }
  if (!isGlobalAmountValid) {
    return locales.numberOfSharesLargerThanTotalError;
  }
  return null;
};

const ManageShares: FC<ManageSharesProps> = ({
  individualNumOfShares = null,
  isGlobalAmountValid,
  onSharesChange,
  sharesData,
}) => {
  if (typeof sharesData === 'undefined') {
    throw new Error('sharesData must be available');
  }

  const { percentOfCapital, totalAmountEuros, totalAmountReleasedEuros } =
    calcApportionedShares(sharesData, individualNumOfShares);

  const error = getNumberOfSharesInputError(
    individualNumOfShares,
    isGlobalAmountValid,
  );

  return (
    <SimpleGrid columns={2} spacing="space-16">
      <Form.Field
        error={error ?? undefined}
        label={locales.numberOfSharesLabel}
      >
        <Form.Input
          onChange={(event) => {
            const value = parseInt(event.currentTarget.value, 10);
            onSharesChange(Number.isNaN(value) ? null : value);
          }}
          type="text"
          value={individualNumOfShares ?? ''}
        />
      </Form.Field>
      <Form.Field label={locales.percentOfCapitalLabel}>
        <Form.Input disabled type="text" value={percentOfCapital ?? ''} />
      </Form.Field>
      <Form.Field label={locales.amountLabel}>
        <Form.Input disabled type="text" value={totalAmountEuros ?? ''} />
      </Form.Field>
      <Form.Field label={locales.amountToBeReleasedLabel}>
        <Form.Input
          disabled
          type="text"
          value={totalAmountReleasedEuros ?? ''}
        />
      </Form.Field>
    </SimpleGrid>
  );
};

export default ManageShares;
